import React from "react";
import "../about/about.css";
import ThankYou from "../../assets/img/appreciation-night/thank-you.png";
import Date from "../../assets/img/appreciation-night/date.png";


const About = () => {
  return (
    <section className="about" id="about">
      <div className="container">
        <div className="about-wrapper">
          <p className="display-title">Tentang Acara</p>
          <h2 className="display-header mb-4">
            Sebuah Malam <span className="display-gold">Penghargaan</span>
          </h2>
          <div className="text-center about-paragraph">
            <p className="text-center">
              <span className="">Appreciation Night</span> adalah
              sebuah perhelatan tahunan yang diadakan NIEC INDONESIA untuk mengapresiasi pihak yang terlibat dalam terwujudnya mimpi para student kami untuk bisa kuliah di luar negeri. Acara ini dihadiri oleh Instansi Pemerintah, Partner sekolah di seluruh Indonesia, Institusi pendidikan luar negeri, para orang tua student yang anaknya sedang menempuh kuliah di luar negeri, dan beberapa tokoh inspiratif.
            </p>
            <p className="text-center">
              Mengusung tema <em className="">"Sailing Towards Honor"</em>, malam ini menjadi
              simbol perjalanan kebersamaan menuju cita-cita dan pencapaian yang lebih tinggi —
              dirayakan dalam suasana eksklusif dan penuh kehangatan.
            </p>
          </div>
          <div className="mt-5 d-flex justify-content-center">
            <div className="gradient-line" />
          </div>
        </div>
      </div>
      {/* <div className="container">
              <p className="text-center title-head">Sunday,</p>
              <img className="date" src={Date} alt="invite" />
              <div className="text-center">
                <h3><i className="fa-solid fa-location-dot pe-2 red"></i>HARRIS Hotel</h3>
                <h3>& Conventions Denpasar</h3>
                <ul>
                  <li>Jl. Cokroaminoto No.23-25, Pemecutan Kaja,</li>
                  <li>Denpasar Utara, Denpasar City, Bali 80118</li>
                </ul>
              </div>
            <div className="col-lg-6 offset-lg-3 flex">
              <button className="mt-2 btn-dress-code">Dress Code : Formal/resmi warna hitam/putih/silver/gold</button>

              <p className="paragraph">
                Acara Appreciation Night adalah sebuah perhelatan  tahunan yang diadakan NIEC INDONESIA untuk 
                mengapresiasi pihak yang terlibat dalam terwujudnya mimpi para student kami untuk bisa kuliah 
                di luar negeri. Acara ini dihadiri oleh Instansi Pemerintah, Partner sekolah di seluruh Indonesia, 
                Institusi pendidikan luar negeri, para orang tua student yang anaknya sedang menempuh kuliah 
                di luar negeri, dan beberapa tokoh inspiratif.
              </p>

              <ul className="list">
                <li>17:30 &nbsp;Welcoming Dinner</li>
                <li>18:30	&nbsp;Opening Ceremonial</li>
                <li>19:00	&nbsp;Opening Institusi Pemerintah</li>
                <li>19:30	&nbsp;Awarding Night </li>
                <li>20:00	&nbsp;Motivational Speech & Talkshow</li>
                <li>21:00	&nbsp;Closing & Foto Bersama</li>
              </ul>
            </div>
          <div className="justify-content mt-5">
              <img className="thank-you" src={ThankYou} alt="thank-you" />
          </div>
        </div> */}
    </section>
  );
};

export default About;
